<template>
  <div class="flex h-full flex-col items-stretch gap-2 pt-2">
    <!-- <ConfirmDialog
      message="Если изменить адрес, то меню может измениться, хотите поменять?"
      :show="showConfirmDialog"
      @confirmed="onConfirmSelection()"
      @rejected="onRejectedSelection()"
      @close="showConfirmDialog = false"
    /> -->
    <div class="relative h-0 grow" ref="restaurantRefEl">
      <HeadlessRadioGroup
        v-model="selectedRestaurant"
        class="scrollbar-hide flex h-full flex-col items-stretch gap-2 overflow-y-auto scroll-smooth py-2"
        :by="compareRests"
      >
        <HeadlessRadioGroupOption
          v-for="restaurant in restaurants"
          :key="restaurant.id"
          v-slot="{ active, checked }"
          as="template"
          :value="restaurant"
          :data-scroll-id="'rest'+restaurant.id"
        >
          <button
            class="rounded-xl border-2 border-transparent bg-white p-2 shadow-main outline-none transition-colors text-left"
            :class="{
              '!border-orange-200': checked,
              'border-orange-100': active,
            }"
          >
            <div class="mb-1 flex">
              <IconMapPoint class="mr-2 w-5" />
              <div>
                {{ restaurant.address }}
              </div>
            </div>
            <div class="flex text-sm">
              <div class="ml-7 opacity-50">
                {{ restaurant.from_hour }}
              </div>
            </div>
          </button>
        </HeadlessRadioGroupOption>
      </HeadlessRadioGroup>

      <div class="absolute left-0 right-0 top-0 h-2 bg-gradient-to-b from-whitegray to-transparent"></div>
      <div class="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-t from-whitegray to-transparent"></div>
    </div>

    <SimpleButton
      class="px-4 py-4 font-medium uppercase"
      type="button"
      :disabled="!selectedRestaurant"
      @click="onConfirmSelection"
    >
      Выбрать
    </SimpleButton>
  </div>
</template>

<script setup lang="ts">
import { toRaw } from 'vue';
const emit = defineEmits(['updateCoords', 'close', 'locationChanged', 'markersUpdated'])

const { data: restaurants } = useRestaurants((v) => v)

const itemRefs = ref([])

watch(restaurants, (res) => {
    if (res) {
        let m: any[] = []
        res.forEach((item) => {
            m.push({
                Lng: item.lng,
                Lat: item.lat,
                restaurantId: item.id,
                onClick: () => {

                    selectedRestaurant.value = item
                    let elementsToScrollTo = document.querySelectorAll('[data-scroll-id="rest'+item.id+'"]')
                    if(elementsToScrollTo.length < 1) return

                    let elementToScrollTo = elementsToScrollTo[0];

                    const childOffset = 1
                    for (let i = 0; i < childOffset; i++) {
                        if (!elementToScrollTo?.previousElementSibling) {
                            break;
                        }
                        elementToScrollTo = elementToScrollTo?.previousElementSibling;
                    }
                    elementToScrollTo.scrollIntoView();

                    /*
                    if(itemsArr && itemsArr.length > 1){
                        const min = (values) => values.reduce((x, y) => Math.min(x, y));
                        const max = (values) => values.reduce((x, y) => Math.max(x, y));
                        const min1 = min(coords1);
                        const min2 = min(coords2);
                        const max1 = max(coords1);
                        const max2 = max(coords2);

                        map.setLocation({
                            bounds: [
                                [min2, min1],
                                [max2, max1],
                            ],
                        });
                    }
                     */

                }
            })
        })

        emit('markersUpdated', m)
    }
}, {immediate: true})

const selectedRestaurant = ref<IRestaurant>()

const compareRests = (a?: IRestaurant, b?: IRestaurant) => {
  return a?.id === b?.id
}

watchEffect(() => {
  if (selectedRestaurant.value) {
    emit('updateCoords', [selectedRestaurant.value.lng, selectedRestaurant.value.lat])
  }
})

const { data: currentReceptionWay } = useCurrentReceptionWay()
watch(
  [currentReceptionWay],
  () => {
    if (currentReceptionWay.value && currentReceptionWay.value.type === 'restaurant') {
      selectedRestaurant.value = currentReceptionWay.value
    }
  },
  {
    immediate: true,
  }
)

const setCurrentReceptionWay = useSetCurrentReceptionWay()

const selectRestaurant = () => {
  if (selectedRestaurant.value) {
    setCurrentReceptionWay({
      type: 'restaurant',
      ...selectedRestaurant.value,
    })
    emit('close')
  }
}

const showConfirmDialog = ref(false)
const onConfirmSelection = () => {
  showConfirmDialog.value = false
  emit('locationChanged')
  selectRestaurant()
}
const onRejectedSelection = () => {
  showConfirmDialog.value = false
}
</script>
